module.exports = __webpack_public_path__ + "img/view-all.f33d8bdd.svg";